import React from 'react';
import { Texto } from '../Texto';
export var BlockTexto = function (_a) {
    var texto = _a.texto, align = _a.align, fontSize = _a.fontSize, bold = _a.bold;
    return (React.createElement(Texto, { texto: texto, align: align, fontSize: fontSize, bold: bold }));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockTexto.tsx
// module id = 256
// module chunks = 0